export interface IWorldState {
    worldNumber: number;
    firstComplete?: boolean;
    firstLoad?: boolean;
    starsGained?: number;
    petSpawnLevel?: number;
}

export const initialWorldState: IWorldState = {
    worldNumber: 1,
    firstComplete: false,
    firstLoad: true,
};
